// @flow

import React from 'react';
import { connect } from 'react-redux';
import { BEST_OF, getMediaByGallery } from '../../../utils/keepeekUtils';
import type { MediaGallery } from '../../../types/keepeekType';
import { openModalWithElements } from '../../../state/page/pageService';
import Loader from '../../common/Loader';

type Props = {
  shoppingCenterMedia: MediaGallery[],
  openModalWithElements: Function,
}

function Intro(props: Props) {
  const bestOfImages = getMediaByGallery(props.shoppingCenterMedia, BEST_OF)
    .sort((a, b) => a.order - b.order);
  const headerImg = bestOfImages[0];
  if (!headerImg) {
    return (
      <Loader isLoading />
    );
  }
  return (
    <div
      className="best-of-image-container"
      role="button"
      onClick={() => {
        props.openModalWithElements({
          medias: bestOfImages,
          itemSelected: 0,
          isOpen: true,
          isAlreadyLoaded: true,
        });
      }}
    >
      <img
        alt="Best of"
        className="best-of-image"
        src={headerImg.fullscreen}
      />
    </div>
  );
}

export default connect(state => ({
  shoppingCenterMedia: state.shoppingCenterFilters.shoppingCenterMedia,
}), { openModalWithElements })(Intro);
